export default {
  sidebar: {
    tasks: 'Tasks',
    tickets: 'Tickets',
  },
};
